export const phoneRegex = /^(?:[+](?:[1-9]\d{0,2})|00[1-9]\d{0,2})?[\s.\-]?[1-9](?:[\s.\-]?\d){8,13}$/v;
